<template>
  <v-layout row wrap>
    <v-flex xs12 class="di-flex justify-space-between align-center my-3">
      <strong class="title_label">
        <span>{{ $t(`workshops`) }}</span>
      </strong>
      <v-spacer />
      <v-btn
        icon
        flat
        class="ma-0 pa-0"
        color="grey darken-2"
        @click="printTable(false)"
      >
        <v-icon>print</v-icon>
      </v-btn>
      <v-btn
        icon
        flat
        class="ma-0 pa-0"
        color="grey darken-2"
        @click="printTable(true)"
      >
        <v-icon>file_download</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12>
      <v-data-table
        ref="tbl"
        item-key="id"
        :items="items"
        :search="search"
        :headers="headers"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.section.join(",") }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.organizer }}</td>
          <td>{{ props.item.start_date }}</td>
          <td>{{ props.item.end_date }}</td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "workshops",
  props: ["items", "cso"],
  data() {
    return {
      search: null
    };
  },
  computed: {
    headers: vm => [
      { text: vm.$t("id"), sortable: false, width: "60px" },
      {
        width: "120px",
        value: "section",
        text: vm.$t("section"),
        computed: item => item.section.join(",")
      },
      { text: "Training Title", value: "name", width: "120px" },
      { text: "Training Conducted By", value: "organizer", width: "120px" },
      { text: vm.$t("start_date"), value: "start_date", width: "120px" },
      { text: vm.$t("end_date"), value: "end_date", width: "120px" }
    ]
  },

  methods: {
    printTable(excel) {
      let data = {
        title: `${this.cso.name}'s ${this.$t("workshops")}`,
        items: this.items,
        headers: this.headers.slice(1)
      };

      if (excel) return this.xl_tables(data, this.$t("workshops"));
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    }
  }
};
</script>
